import React from 'react';
import { TopToolbar, Button, useDataProvider, useNotify } from 'react-admin';
import { Done, Undo, NotInterested } from '@material-ui/icons';

const ApprovableAdminActionShowActions = ({ data }) => {
	const dataProvider = useDataProvider();
	const notify = useNotify();

	const handleAction = (method) => {
		dataProvider.create('approvableAdminActions', { id: data.id, method })
			.then(() => {
				notify(`resources.approvableAdminActions.notifications.${method}Success`, 'info');
			})
			.catch(error => {
				notify(error.message, 'error');
			});
	};

	const approve = () => {
		handleAction('approve');
	};

	const revoke = () => {
		handleAction('revoke');
	}

	const decline = () => {
		handleAction('decline');
	}

	const buttonProps = {
		component: 'button',
		color: 'primary',
		disabled: data && data.status !== 'Created',
	};

	return (
		<TopToolbar>
			{data && (
				<React.Fragment>
					<Button
						label="resources.approvableAdminActions.actions.approve"
						onClick={approve}
						{...buttonProps}
					>
						<Done />
					</Button>
					<Button
						label="resources.approvableAdminActions.actions.revoke"
						onClick={revoke}
						{...buttonProps}
					>
						<Undo />
					</Button>
					<Button
						label="resources.approvableAdminActions.actions.decline"
						onClick={decline}
						{...buttonProps}
					>
						<NotInterested />
					</Button>
				</React.Fragment>
			)}
		</TopToolbar>
	);
};

export default ApprovableAdminActionShowActions;
